import * as R from "ramda";

export default R.curry((value, array) => {
  if (Array.isArray(value)) {
    return R.symmetricDifference(value, array);
  } else {
    return R.symmetricDifference([value], array);
  }
});
